import { useMutation } from '@tanstack/react-query';
import { apiFetch } from './api';
import { Context } from '../../../context';
import { useContext } from 'react';

export const useSurvey = ({ url, onSuccess, onError }) => {
  const context = useContext(Context);

  const mutation = useMutation({
    mutationFn: async (data) => {
      console.log('Submitting survey data:', data);
      await apiFetch(`${process.env.REACT_APP_API_URL}${url}`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
    },
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (error) => {
      if (onError) {
        onError(error);
      }
      if (error?.status === 401) {
        context.logout();
      }
    },
  });
  return mutation;
};
